import React, { useContext, useState } from 'react';
import FilterCtx from '../../../../../context/filterContext/filterCtx';
import useTranslate from '../../../../../common/hooks/useTranslate';
import DocNameFilter from '../../../../ui/filters/docNameFilter/docNameFilter';
import FundsFilter from '../../../../ui/filters/fundsFilter/fundsFilter';
import InvestorsFilter from '../../../../ui/filters/investorsFilter/investorsFilter';
import ClassificationsFilter from '../../../../ui/filters/classificationsFilter/classificationsFilter';
import ActivityFeedPeriodFilter from '../../../../ui/filters/activityFeedPeriodFilter/activityFeedPeriodFilter';

import '@progress/kendo-theme-default/dist/all.css';
import '../../../../documents/components/documentsTable/documentsTable.scss';
import '../../../../../common/styles/globalClasses.scss';
import '../../../../ui/filters/filters.scss';
import './activityTableFilters.scss';
import TypePickerFilter from '../../../../ui/filters/typePickerFilter/typePickerFilter';

const ActivityTableFilters = () => {
  const filterCtx = useContext(FilterCtx);
  const [doRerender, setDoRerender] = useState(true);
  const [uniqueKey, setUniqueKey] = useState('');

  const { t } = useTranslate();

  const resetFilters = () => {
    const date = new Date();
    setUniqueKey(date.toString());
    filterCtx.clearFiltersActivity();
    setDoRerender(!doRerender);
  };

  return (
    <>
      <div className='filters'>
        <div className='filters-group'>
          <TypePickerFilter className='hidden-mobile' />
          <DocNameFilter
            //@ts-ignore
            key={!doRerender}
            className='hidden-mobile'
            table='activity'
          />
          <div className='type-search-filters hidden-desktop'>
            <TypePickerFilter />
            <DocNameFilter
              //@ts-ignore
              key={!doRerender}
              table='activity'
            />
          </div>
          <ActivityFeedPeriodFilter key={uniqueKey + 4} />
        </div>
        <div className='filters-multiselect hidden-mobile'>
          <ClassificationsFilter key={uniqueKey + 3} table='activity' />
          <FundsFilter key={uniqueKey + 1} table='activity' />
          <InvestorsFilter key={uniqueKey + 2} table='activity' />
        </div>
        <button type='button' className='filter-button reset' disabled={!filterCtx.hasActivityFilters()}
                onClick={resetFilters}>
          {t('FILTERS.BUTTON_RESET')}
        </button>
      </div>
    </>
  );
};

export default ActivityTableFilters;
